import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-232d8ced"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hello-banner" }
const _hoisted_2 = { class: "banner-text" }
const _hoisted_3 = { class: "dashboard-side desktop" }
const _hoisted_4 = { class: "data-number border" }
const _hoisted_5 = { class: "chart-area" }
const _hoisted_6 = { class: "border-title" }
const _hoisted_7 = { class: "static-area" }
const _hoisted_8 = { class: "static-row mt-1" }
const _hoisted_9 = { class: "static-main-number" }
const _hoisted_10 = { class: "main-description" }
const _hoisted_11 = { class: "date mt-1" }
const _hoisted_12 = {
  key: 0,
  class: "static-row mt-1"
}
const _hoisted_13 = { class: "description" }
const _hoisted_14 = { class: "static-number" }
const _hoisted_15 = { class: "description" }
const _hoisted_16 = { class: "grid-item first" }
const _hoisted_17 = { class: "table-title" }
const _hoisted_18 = { class: "border-title tagline-title" }
const _hoisted_19 = { class: "table-list" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "other-leading" }
const _hoisted_23 = { class: "title-text" }
const _hoisted_24 = { class: "sub-text" }
const _hoisted_25 = {
  key: 0,
  class: "thin-divider"
}
const _hoisted_26 = {
  key: 0,
  class: "thin-divider"
}
const _hoisted_27 = {
  key: 2,
  class: "content-empty"
}
const _hoisted_28 = { class: "grid-item last" }
const _hoisted_29 = { class: "table-title" }
const _hoisted_30 = { class: "border-title tagline-title" }
const _hoisted_31 = { class: "table-list" }
const _hoisted_32 = { class: "list-tile" }
const _hoisted_33 = ["src"]
const _hoisted_34 = ["src"]
const _hoisted_35 = ["src"]
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "other-leading" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = {
  key: 0,
  class: "thin-divider"
}
const _hoisted_40 = {
  key: 0,
  class: "content-empty"
}
const _hoisted_41 = { class: "dashboard-side mobile" }
const _hoisted_42 = { class: "data-number border" }
const _hoisted_43 = { class: "chart-area" }
const _hoisted_44 = { class: "border-title" }
const _hoisted_45 = { class: "static-area" }
const _hoisted_46 = { class: "static-row mt-1" }
const _hoisted_47 = { class: "static-main-number" }
const _hoisted_48 = { class: "main-description" }
const _hoisted_49 = { class: "date mt-1" }
const _hoisted_50 = { class: "static-row mt-1" }
const _hoisted_51 = { class: "description" }
const _hoisted_52 = { class: "static-number" }
const _hoisted_53 = { class: "description" }
const _hoisted_54 = { class: "dashboard-content" }
const _hoisted_55 = { class: "contract-status-content mt-3" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 0,
  class: "elapsed-time"
}
const _hoisted_58 = {
  key: 2,
  class: "empty-chart mt-3"
}
const _hoisted_59 = {
  key: 3,
  class: "ranking-content mt-3"
}
const _hoisted_60 = { class: "dashboard-side mobile" }
const _hoisted_61 = { class: "grid-item first" }
const _hoisted_62 = { class: "table-title" }
const _hoisted_63 = { class: "border-title tagline-title" }
const _hoisted_64 = { class: "table-list" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["src"]
const _hoisted_67 = { class: "other-leading" }
const _hoisted_68 = { class: "title-text" }
const _hoisted_69 = { class: "sub-text" }
const _hoisted_70 = {
  key: 0,
  class: "thin-divider"
}
const _hoisted_71 = {
  key: 0,
  class: "thin-divider"
}
const _hoisted_72 = {
  key: 2,
  class: "content-empty"
}
const _hoisted_73 = { class: "grid-item" }
const _hoisted_74 = { class: "table-title" }
const _hoisted_75 = { class: "border-title tagline-title" }
const _hoisted_76 = { class: "table-list" }
const _hoisted_77 = { class: "list-tile" }
const _hoisted_78 = ["src"]
const _hoisted_79 = ["src"]
const _hoisted_80 = ["src"]
const _hoisted_81 = ["src"]
const _hoisted_82 = { class: "other-leading" }
const _hoisted_83 = ["innerHTML"]
const _hoisted_84 = {
  key: 0,
  class: "thin-divider"
}
const _hoisted_85 = {
  key: 0,
  class: "content-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextButton = _resolveComponent("TextButton")!
  const _component_BarChart = _resolveComponent("BarChart")!
  const _component_UserRanking = _resolveComponent("UserRanking")!
  const _component_FileRanking = _resolveComponent("FileRanking")!
  const _component_AfterLoginPageLayout = _resolveComponent("AfterLoginPageLayout")!
  const _component_AccessCodePopup = _resolveComponent("AccessCodePopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AfterLoginPageLayout, {
      class: "dashboard",
      "is-sub-header-menu": true,
      "right-part-popup": false
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.bannerText + _ctx.userFullName + _ctx.$t('dashboard.bannerTextEnd')), 1)
        ])
      ]),
      bottomRight: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("dashboard.chartTitle")), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.summary.completedContractNumber), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("dashboard.countText")), 1)
                ]),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.summary.currentMonth), 1),
                (_ctx.accountInfo.planType < 100)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("dashboard.overContractCompleted")), 1),
                      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.overContractNumber), 1),
                      _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("dashboard.countText")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["grid-container", { 'mt-1': _ctx.accountInfo.planType > _ctx.Plan.PlanType.FREE_PLAN }])
          }, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("dashboard.needSignContract")), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.needToSignContracts, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id
                  }, [
                    _createElementVNode("div", {
                      class: "list-tile pointer",
                      onClick: ($event: any) => (_ctx.handleNeedToSignContract(item))
                    }, [
                      _createElementVNode("img", {
                        src: require('icons/report_orange.svg'),
                        alt: "notification icon",
                        class: "mr-1"
                      }, null, 8, _hoisted_21),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("p", _hoisted_23, _toDisplayString(item.title), 1),
                        _createElementVNode("p", _hoisted_24, _toDisplayString(`${_ctx.$t("template.lastUpdate")} ${_ctx.formatDate(item.updatedAt, "YYYY/MM/DD")}`), 1)
                      ])
                    ], 8, _hoisted_20),
                    (i + 1 != _ctx.needToSignContracts.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_ctx.needToSignContracts.length >= 5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26))
                  : _createCommentVNode("", true),
                (_ctx.needToSignContracts.length >= 5)
                  ? (_openBlock(), _createBlock(_component_TextButton, {
                      key: 1,
                      onOnClick: _ctx.viewAllConfirmRequest,
                      class: "view-all-button",
                      text: _ctx.$t('dashboard.viewAllNeedSignContract'),
                      icon: require('icons/read_more.svg')
                    }, null, 8, ["onOnClick", "text", "icon"]))
                  : _createCommentVNode("", true),
                (_ctx.needToSignContracts.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.$t("dashboard.noNeedSignContract")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t("dashboard.otherNotification")), 1)
              ]),
              _createElementVNode("div", _hoisted_31, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id
                  }, [
                    _createElementVNode("div", _hoisted_32, [
                      (item.type == _ctx.NOTIFICATION_TYPE.CONTRACT)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: require('icons/report_orange.svg'),
                            alt: "notification icon",
                            class: "mr-1"
                          }, null, 8, _hoisted_33))
                        : (item.type == _ctx.NOTIFICATION_TYPE.TEMPLATE)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: require('icons/primary-template.svg'),
                              alt: "notification icon",
                              class: "mr-1"
                            }, null, 8, _hoisted_34))
                          : (item.type == _ctx.NOTIFICATION_TYPE.CONTRACT_FOLDER || item.type == _ctx.NOTIFICATION_TYPE.TEMPLATE_FOLDER)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 2,
                                src: require('icons/primary-folder.svg'),
                                alt: "notification icon",
                                class: "mr-1"
                              }, null, 8, _hoisted_35))
                            : (item.type == _ctx.NOTIFICATION_TYPE.GROUP)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 3,
                                  src: require('icons/primary-view.svg'),
                                  alt: "notification icon",
                                  class: "mr-1"
                                }, null, 8, _hoisted_36))
                              : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("p", {
                          innerHTML: item.content,
                          class: "title"
                        }, null, 8, _hoisted_38)
                      ])
                    ]),
                    (i != _ctx.notifications.length - 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_ctx.notifications.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.$t("dashboard.noContract")), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 2)
        ])
      ]),
      bottomLeft: _withCtx(() => [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t("dashboard.chartTitle")), 1),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.summary.completedContractNumber), 1),
                  _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t("dashboard.countText")), 1)
                ]),
                _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.summary.currentMonth), 1),
                _createElementVNode("span", _hoisted_50, [
                  _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.$t("dashboard.overContractCompleted")), 1),
                  _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.overContractNumber), 1),
                  _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.$t("dashboard.countText")), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contractStatus, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option.id,
                class: "status-item"
              }, [
                _createElementVNode("button", {
                  class: _normalizeClass(["radius-button", option.class]),
                  onClick: option.event
                }, _toDisplayString(option.name), 11, _hoisted_56),
                _createElementVNode("span", null, _toDisplayString(option.count) + _toDisplayString(_ctx.$t("dashboard.countText")), 1)
              ]))
            }), 128))
          ]),
          (_ctx.loaded && _ctx.chartData.datasets.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_ctx.$t("dashboard.elapsedTime", { time: _ctx.averageElapsedTime })), 1))
            : _createCommentVNode("", true),
          (_ctx.loaded && _ctx.chartData.datasets.length > 0)
            ? (_openBlock(), _createBlock(_component_BarChart, {
                key: 1,
                class: "bar-chart",
                data: _ctx.chartData,
                options: _ctx.chartOptions
              }, null, 8, ["data", "options"]))
            : (_ctx.loaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_ctx.$t("dashboard.emptyChart")), 1))
              : _createCommentVNode("", true),
          (_ctx.loaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                _createVNode(_component_UserRanking, {
                  data: _ctx.rankingContractData,
                  title: _ctx.$t('dashboard.rankingContractTitle')
                }, null, 8, ["data", "title"]),
                _createVNode(_component_UserRanking, {
                  data: _ctx.rankingSignData,
                  title: _ctx.$t('dashboard.rankingSignTitle'),
                  class: "center"
                }, null, 8, ["data", "title"]),
                _createVNode(_component_FileRanking, {
                  data: _ctx.rankingTemplateData,
                  title: _ctx.$t('dashboard.rankingTemplateTitle')
                }, null, 8, ["data", "title"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", {
            class: _normalizeClass(["grid-container", { 'mt-1': _ctx.accountInfo.planType > _ctx.Plan.PlanType.FREE_PLAN }])
          }, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.$t("dashboard.needSignContract")), 1)
              ]),
              _createElementVNode("div", _hoisted_64, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.needToSignContracts, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id
                  }, [
                    _createElementVNode("div", {
                      class: "list-tile pointer",
                      onClick: ($event: any) => (_ctx.handleNeedToSignContract(item))
                    }, [
                      _createElementVNode("img", {
                        src: require('icons/report_orange.svg'),
                        alt: "notification icon",
                        class: "mr-1"
                      }, null, 8, _hoisted_66),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("p", _hoisted_68, _toDisplayString(item.title), 1),
                        _createElementVNode("p", _hoisted_69, _toDisplayString(`${_ctx.$t("template.lastUpdate")} ${_ctx.formatDate(item.updatedAt, "YYYY/MM/DD")}`), 1)
                      ])
                    ], 8, _hoisted_65),
                    (i + 1 != _ctx.needToSignContracts.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_70))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_ctx.needToSignContracts.length >= 5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71))
                  : _createCommentVNode("", true),
                (_ctx.needToSignContracts.length >= 5)
                  ? (_openBlock(), _createBlock(_component_TextButton, {
                      key: 1,
                      onOnClick: _ctx.viewAllConfirmRequest,
                      class: "view-all-button",
                      text: _ctx.$t('dashboard.viewAllNeedSignContract'),
                      icon: require('icons/read_more.svg')
                    }, null, 8, ["onOnClick", "text", "icon"]))
                  : _createCommentVNode("", true),
                (_ctx.needToSignContracts.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_ctx.$t("dashboard.noNeedSignContract")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("p", _hoisted_75, _toDisplayString(_ctx.$t("dashboard.otherNotification")), 1)
              ]),
              _createElementVNode("div", _hoisted_76, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id
                  }, [
                    _createElementVNode("div", _hoisted_77, [
                      (item.type == _ctx.NOTIFICATION_TYPE.CONTRACT)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: require('icons/report_orange.svg'),
                            alt: "notification icon",
                            class: "mr-1"
                          }, null, 8, _hoisted_78))
                        : (item.type == _ctx.NOTIFICATION_TYPE.TEMPLATE)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: require('icons/primary-template.svg'),
                              alt: "notification icon",
                              class: "mr-1"
                            }, null, 8, _hoisted_79))
                          : (item.type == _ctx.NOTIFICATION_TYPE.CONTRACT_FOLDER || item.type == _ctx.NOTIFICATION_TYPE.TEMPLATE_FOLDER)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 2,
                                src: require('icons/primary-folder.svg'),
                                alt: "notification icon",
                                class: "mr-1"
                              }, null, 8, _hoisted_80))
                            : (item.type == _ctx.NOTIFICATION_TYPE.GROUP)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 3,
                                  src: require('icons/primary-view.svg'),
                                  alt: "notification icon",
                                  class: "mr-1"
                                }, null, 8, _hoisted_81))
                              : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("p", {
                          innerHTML: item.content,
                          class: "title"
                        }, null, 8, _hoisted_83)
                      ])
                    ]),
                    (i != _ctx.notifications.length - 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_84))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_ctx.notifications.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(_ctx.$t("dashboard.noContract")), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 2)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_AccessCodePopup, {
      "is-show": _ctx.isShowAccessCodePopup,
      onOnHide: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowAccessCodePopup = false)),
      onOnInputAccessCode: _ctx.handleInputAccessCode
    }, null, 8, ["is-show", "onOnInputAccessCode"])
  ], 64))
}